// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"aa0a63e4","318":"497de081","457":"541ee61c","527":"2639d210","709":"307270e0","788":"32d5c941","804":"7afd3c6c","819":"ea1b1369","844":"e8b0cf97","871":"792b5f97","922":"babbf056"}[chunkId] + ".chunk.js";
};